import { fromJS, List, Record } from 'immutable';
import { generateKeys, generateSchema, setInModel } from 'i2g-ng-utils';
import { MessageFeed } from './submodels/message-feed.model';
import { ClientInfo } from './submodels/client-info.model';
import { JobEstimate } from './submodels/job-estimate.model';
import { Attachments } from './submodels/attachments.model';
import { JobNote } from './submodels/job-note.model';

// TODO: refactor to use interface as model

export const JOB_PORTAL_DATA_SCHEMA = Object.freeze({
  ID: '',
  JOB_NUMBER: '',
  JOB_CREATED: '',
  MESSAGE_FEED: MessageFeed,
  CLIENT_INFO: ClientInfo,
  ESTIMATES: List<JobEstimate>([]),
  ATTACHMENTS: List<Attachments>([]),
  NOTE: null,
});

export const RECORD = generateSchema(JOB_PORTAL_DATA_SCHEMA);
export const KEYS: any = generateKeys(JOB_PORTAL_DATA_SCHEMA);

export class JobPortalData extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.MESSAGE_FEED,
        value: props.get(KEYS.MESSAGE_FEED)
          ? new MessageFeed(this.messageFeed)
          : null,
      },
      {
        key: KEYS.CLIENT_INFO,
        value: props.get(KEYS.CLIENT_INFO)
          ? new ClientInfo(this.clientInfo)
          : null,
      },
      {
        key: KEYS.ESTIMATES,
        value: props.get(KEYS.ESTIMATES)
          ? this.estimates.map((params) => new JobEstimate(params))
          : List<JobEstimate>([]),
      },
      {
        key: KEYS.ATTACHMENTS,
        value: props.get(KEYS.ATTACHMENTS)
          ? this.attachments.map((params) => new Attachments(params))
          : List<Attachments>([]),
      },
      {
        key: KEYS.NOTE,
        value: props.get(KEYS.NOTE) ? new JobNote(this.note) : null,
      },
    ]);

    return selfModel as JobPortalData;
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get jobNumber(): string {
    return this.get(KEYS.JOB_NUMBER);
  }

  get jobCreated(): string {
    return this.get(KEYS.JOB_CREATED);
  }

  get messageFeed(): MessageFeed {
    return this.get(KEYS.MESSAGE_FEED);
  }

  get clientInfo(): ClientInfo {
    return this.get(KEYS.CLIENT_INFO);
  }

  get estimates(): List<JobEstimate> {
    return this.get(KEYS.ESTIMATES);
  }

  get attachments(): List<Attachments> {
    return this.get(KEYS.ATTACHMENTS);
  }

  get note(): JobNote {
    return this.get(KEYS.NOTE);
  }
}
